import { IconButton, TableRow, TableRowColumn, TextField } from 'material-ui';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styles from 'styles';
import LinksTags from './LinksTags';
import moment from 'moment';

import { addNotification } from 'actions/notifications/notifications';
import SaveIcon from 'material-ui/svg-icons/content/save';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import OpenUrl from 'material-ui/svg-icons/action/open-in-new';
import helpers from 'helpers';

import api from 'services';

function LinksRow({ key, item, addNotification, handleModifyLinksList }) {
    const [value, setValue] = useState(item.value);
    const [tags, setTags] = useState(item.tags.map((t) => {
        return { ...t, name: t.value };
    }));
    const [toUpdate, setToUpdate] = useState(false);

    const changeValue = (e) => {
        setValue(e.target.value);
        setToUpdate(true);
    };
    
    const changeTags = (_tags) => {
        setTags(_tags.map((t) => {
            return { ...t, value: t.name };
        }));
        setToUpdate(true);
    };

    const handleUpdate = async () => {
        if (!value) {
            addNotification({
                title: 'Error',
                message: 'Value can not be empty',
                level: 'error',
                _id: new Date().getMilliseconds(),
                autoDismiss: 3,
            });
        }

        const response = await api.updateAnalyticsLinksList({ ...item, value, tags });

        if (!response.errors.length) {
            addNotification({
                title: 'Success',
                message: 'Record updated successfully',
                level: 'success',
                _id: new Date().getMilliseconds(),
                autoDismiss: 3,
            });
            setToUpdate(false);
        } else {
            addNotification({
                title: 'Error',
                message: response.errors[0].message || response.errors[0].messages[0],
                level: 'error',
                _id: new Date().getMilliseconds(),
                autoDismiss: 3,
            });
        }
    };

    const handleDelete = async () => {
        const response = await api.deleteAnalyticLink(item._id);

        if (!response.errors.length) {
            addNotification({
                title: 'Success',
                message: 'Record removed successfully',
                level: 'success',
                _id: new Date().getMilliseconds(),
                autoDismiss: 3,
            });
            setToUpdate(false);
            handleModifyLinksList();
        } else {
            addNotification({
                title: 'Error',
                message: response.errors[0].message || response.errors[0].messages[0],
                level: 'error',
                _id: new Date().getMilliseconds(),
                autoDismiss: 3,
            });
        }
    };

    const urlInValue = value && helpers.getUrlFromString(value);

    return (
        <TableRow
            key={key}
        >
            <TableRowColumn 
                style={{...styles.tableRowColumnCSS, width: '53%', maxWidth: 'unset'}}
                className='cargo-realnames_name_column'
            >
                <TextField 
                    name={`record_${key}`}
                    value={value}
                    onChange={changeValue}
                    style={{ fontSize: '14px', width: '90%' }}
                    multiLine
                    rowsMax={10}
                />
                <IconButton disabled={!urlInValue} style={{ transform: 'translateY(10px)' }}> 
                    <OpenUrl
                        onClick={() => urlInValue && window.open(urlInValue, '_blank')}
                    />
                </IconButton>
            </TableRowColumn>

            <TableRowColumn
                style={{ width: '17%', padding: 0 }}
            >
                User: { item.addedBy.email } <br />
                Date: { moment(item.createdAt).format('lll') }
            </TableRowColumn>

            <TableRowColumn style={{...styles.tableHeaderColumnSmallCSS, width: '20%'}}>
                <LinksTags 
                    placeHolder='Add tags'
                    tags={tags}
                    setTags={changeTags}
                />
            </TableRowColumn>

            <TableRowColumn style={{...styles.tableHeaderColumnSmallCSS, display: 'flex', margin: 'auto'}}>
                <div className={toUpdate ? '' : 'hidden'} style={{ textAlign: 'center' }}>
                    <IconButton>
                        <SaveIcon
                            onClick={handleUpdate}
                            style={{ margin: '70px 0 0 0' }}
                            color='#09BCD4'
                        />
                    </IconButton>
                </div>
                <div style={{ textAlign: 'center' }}>
                    <IconButton>
                        <DeleteIcon
                            onClick={handleDelete}
                            style={{ margin: '70px 0 0 0' }}
                            color='#FF7DA9'
                        />
                    </IconButton>
                </div>
            </TableRowColumn>
        </TableRow>
    );
}

export default connect(
    (state) => {
        return {
            realCompaniesIds: state.realCompanies.items.map(c => c._id),
        };
    },
    dispatch => bindActionCreators({
        addNotification,
    },
    dispatch),
)(LinksRow);



// WEBPACK FOOTER //
// ./app/components/Analytics/LinksRow.jsx